import { GQLGiftImageFormatType } from 'generated-graphql/graphql'

export interface Format {
  svg: GQLGiftImageFormatType
  png: GQLGiftImageFormatType
}

export const findGiftFormat = (
  imageFormats: GQLGiftImageFormatType[]
): Format => {
  const svg = imageFormats.find(
    ({ formatId }) => formatId === 7
  ) as GQLGiftImageFormatType
  const png = imageFormats.find(
    ({ formatId }) => formatId === 3
  ) as GQLGiftImageFormatType

  return {
    svg,
    png,
  }
}
